export default __webpack_public_path__ + "static/media/carrousel-sncc-3grau.51ae6934.png";